var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5971 6.52428C14.5967 6.52393 14.5964 6.52359 14.596 6.52325L8.4766 0.404663C8.21576 0.143738 7.86897 0 7.50009 0C7.13121 0 6.78442 0.143623 6.52347 0.404549L0.407238 6.52004C0.405178 6.5221 0.403117 6.52428 0.401057 6.52634C-0.134581 7.06501 -0.133665 7.939 0.40369 8.4763C0.64919 8.72189 0.973435 8.86414 1.32011 8.87901C1.33419 8.88039 1.34838 8.88107 1.36269 8.88107H1.60659V13.384C1.60659 14.275 2.33164 15 3.223 15H5.61712C5.85976 15 6.05662 14.8033 6.05662 14.5605V11.0303C6.05662 10.6237 6.38739 10.2929 6.79404 10.2929H8.20615C8.6128 10.2929 8.94357 10.6237 8.94357 11.0303V14.5605C8.94357 14.8033 9.14031 15 9.38307 15H11.7772C12.6685 15 13.3936 14.275 13.3936 13.384V8.88107H13.6198C13.9885 8.88107 14.3353 8.73745 14.5964 8.47652C15.1343 7.93831 15.1345 7.06284 14.5971 6.52428Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.c03cd1894cfaaa15803e2b1cef7c3b19.svg";
export { ForwardRef as ReactComponent };